import Core from '../plugin-core-system/core.class.js';
import DeviceDetection from '../helper/device-detection.helper.js';
import Cookies from 'js-cookie';

export default class CsEdgeNav extends Core {

  static options = {
    scrollCollapseAt: 400,
    itemSelector: '.js-edge-nav-item',
    linkSelector: '.js-edge-nav-link',
    closeSelector: '.js-edge-nav-close',
    smallClass: 'edge-nav__item--small',
    cookieDays: 7
  };

  initItems() {
    const items = Array.from(this.el.querySelectorAll(this.options.itemSelector));

    // Hide items with existing cookies
    items.forEach((item) => {
      const key = item.dataset.dismissKey;
      if (key && Cookies.get(key) === '1') {
        this.hideItem(item);
      }
    });

    // Hide region if no visible items
    if (!this.anyVisible()) {
      this.hideRegion();
      return;
    }

    this.showRegion();

    // Pointer + focus interactions
    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (DeviceDetection.isTouchDevice()) {
          return;
        }
        this.expand(item);
      });
    });

    this.el.addEventListener('focusin', (e) => {
      if (DeviceDetection.isTouchDevice()) {
        return;
      }
      const item = e.target.closest(this.options.itemSelector);
      if (item) this.expand(item);
    });

    this.el.addEventListener('click', (e) => {
      // for touch devices
      const link = e.target.closest(this.options.linkSelector);
      if (link && this.el.contains(link)) {
        const item = link.closest(this.options.itemSelector);
        if (item && item.classList.contains(this.options.smallClass)) {
          e.preventDefault();
          this.expand(item);
        }
      }

      // close button
      const close = e.target.closest(this.options.closeSelector);
      if (close && this.el.contains(close)) {
        e.preventDefault();

        const item = close.closest(this.options.itemSelector);
        const key = item?.dataset.dismissKey;

        this.fadeOut(item, 150).then(() => {
          if (key) Cookies.set(key, '1', {expires: this.options.cookieDays, path: '/'});
          this.hideItem(item);
          if (!this.anyVisible()) this.hideRegion();
        });
      }
    });

    // Scroll collapse
    window.addEventListener('scroll', () => {
      if (window.scrollY >= this.options.scrollCollapseAt) {
        this.collapseAll();
      }
    }, { passive: true });
  }

  /* ------------------------------------------------------------
   * DOM helpers
   * ------------------------------------------------------------ */

  hideItem(item) {
    item.hidden = true;
    item.setAttribute('aria-hidden', 'true');
    item.style.display = 'none';
  }

  showRegion() {
    this.el.hidden = false;
    this.el.removeAttribute('aria-hidden');
  }

  hideRegion() {
    this.el.hidden = true;
    this.el.setAttribute('aria-hidden', 'true');
  }

  anyVisible() {
    return Array.from(this.el.querySelectorAll(this.options.itemSelector))
      .some(i => !i.hidden && i.style.display !== 'none');
  }

  expand(item) {
    item.classList.remove(this.options.smallClass);
  }

  collapse(item) {
    item.classList.add(this.options.smallClass);
  }

  collapseAll() {
    this.el.querySelectorAll(this.options.itemSelector).forEach((i) => {
      if (!i.hidden) this.collapse(i);
    });
  }

  fadeOut(el, duration = 150) {
    return new Promise((resolve) => {
      if (!el) return resolve();
      el.style.transition = `opacity ${duration}ms ease`;
      el.style.opacity = '1';
      requestAnimationFrame(() => { el.style.opacity = '0'; setTimeout(resolve, duration); });
    });
  }

  init() {
    this.initItems();
  }
}
